import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f10fcc02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forbidden-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-not-found" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl" }, "404"),
    /*#__PURE__*/_createElementVNode("h4", { class: "text-md" }, "페이지가 존재하지 않습니다")
  ])
], -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [..._hoisted_3]))
}